module.exports = __webpack_public_path__ + "img/609.f8f5ee0b.jpg";